(function() {
    'use strict';

    angular.module('aprima-provider-api').factory('PdpmpModalService', [
        '$q',
        'PdpmpModalServiceTs',
        PdpmpModalService
    ]);

    function PdpmpModalService(
        $q,
        PdpmpModalServiceTs
    ) {
        return {
            openModal: openModal,
            shouldAllowModal: shouldAllowModal,
        };

        function openModal(config, serviceSiteId, patientId, providerId, visitId, messageId) {
            var promise = PdpmpModalServiceTs.openModal(config, serviceSiteId, patientId, providerId, visitId, messageId).toPromise();
            return $q.when(promise);
        }

        function shouldAllowModal(config) {
            return PdpmpModalServiceTs.shouldAllowModal(config);
        }
    }
})();